import { useState } from "react";
import styles from "./PrizeNavigation.module.css";
import { useUser } from '../UserContext';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../utils/apiConfig'; // Import the API base URL

const PrizeNavigation = ({ navigationButtonArea, leagueId }) => {
  const [menuOpen, setMenuOpen] = useState(false); // State for toggle menu
  // const { logout } = useUser(); // Use the useUser hook at the top level of the component
  const navigate = useNavigate(); // Hook to navigate programmatically
  const handleCreateLeagueClick = () => {
    navigate('/leaguenamesetup');
  };

  const logout = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/logout`, {
        method: 'POST',
        credentials: 'include', // Include credentials (cookies) in the request
      });

      if (response.ok) {
        // Clear user data from local storage
        localStorage.removeItem('user');
        localStorage.removeItem('leagues');
        localStorage.removeItem('leagueId');

        // Redirect to the login page
        navigate('/');
      } else {
        console.error('Logout failed');
      }
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  const handleNavigateDash = () => {
    navigate('/commissionerdash'); // Navigate to the home page
  };

  const handleNavigateToKeepers = () => {
    if (leagueId) {
      navigate(`/keepers/${leagueId}`);
    } else {
      navigate('/keepers');
    }
  };

  const handleNavigateToPrizes = () => {
    if (leagueId) {
      navigate(`/prizes/${leagueId}`);
    } else {
      navigate('/prizes');
    }
  };

  const handleNavigateToBuzz = () => {
    if (leagueId) {
      navigate(`/buzz/${leagueId}`);
    } else {
      navigate('/buzz');
    }
  };

  const handleNavigateToDraft = () => {
    if (leagueId) {
      navigate(`/draft/${leagueId}`);
    } else {
      navigate('/draft');
    }
  };


  // const handleNavigateToPolls = () => {
  //   navigate(`/polls/${leagueId}`);
  // };

  const handleNavigateToPolls = () => {
    if (leagueId) {
      navigate(`/polls/${leagueId}`);
    } else {
      navigate('/polls');
    }
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen); // Toggle menu function
  };

  return (
    <header className={styles.prizeNavigation}>
      <div className={styles.nav}>
        <img
          className={styles.navigationButtonArea}
          loading="lazy"
          alt=""
          src={navigationButtonArea}
          onClick={handleNavigateDash}
        />
        {/* Hamburger menu */}
          <div className={styles.hamburger} onClick={toggleMenu}>
          <div></div>
          <div></div>
          <div></div>
        </div>
        {/* Add 'open' class based on state */}
        <div className={`${styles.memberNavButton} ${menuOpen ? styles.open : ""}`}>
          <ul>
            <li className={styles.members}><a href ="/commissionerdash">League</a></li>
            <li className={styles.polls}><a onClick={handleNavigateToPolls}>Polls</a></li>
            <li className={styles.keepers}><a onClick={handleNavigateToKeepers}>Keepers</a></li>
            <li className={styles.prizes}><a onClick={handleNavigateToPrizes}>Prizes</a></li>
            <li className={styles.buzz}><a onClick={handleNavigateToBuzz}>Buzz</a></li>
            <li className={styles.draft}><a onClick={handleNavigateToDraft}>Draft Results</a></li>
            <li className={styles.players}><a href="/players">Players</a></li>
            {/* Show Create League only in hamburger menu */}
              {menuOpen && (
                <li className={styles.createLeague}>
                  <a onClick={handleCreateLeagueClick} id="createLeague">
                    Create League
                  </a>
                </li>
              )}        
          </ul>
        </div>
        <div className={styles.logoutContainer}>
          {/* Show Create League only outside the hamburger menu */}
          {!menuOpen && (
            <a href="#"
              className={styles.createLeagueButton}
              id="createLeagueButton"
              onClick={handleCreateLeagueClick}
            >
            Create league
          </a>
         )}
          <a 
            href="#" // Prevent default navigation
            onClick={(e) => { e.preventDefault(); logout(); }}
            className={styles.logout}
          >
            Logout
          </a>
        </div>
      </div>
    </header>
  );
};

export default PrizeNavigation;
